// Which leads each SMS Center config reaches. Shared by the sidebar badges and
// the SmsAudienceNotice banner so a config and its logs page always match.
export const SMS_AUDIENCES = {
  csv: { text: 'CSV', color: 'secondary' },
  api: { text: 'API', color: 'info' },
  sites: { text: 'Sites', color: 'success' },
}
